import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { encodeId, formatAmount, formatNotifDate } from "../../../utils/common";
import { useNavigate } from "react-router-dom";

function Deposit_Not_Received_Card({
  badge = "Recharge",
  withdrawHistory,
  diposit_history,
}) {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  // Badge background color
  const badgeStyle = {
    backgroundColor: badge === "Recharge" ? "#009A55" : "#F56664",
    color: "#fff",
  };

  // Status color based on RequestStatus.name
  const getStatusStyle = (statusName) => ({
    color:
      statusName === "Accepted"
        ? "#37BB80"
        : statusName === "Failed" || statusName === "Rejected"
          ? "#F56664"
          : statusName === "Processing"
            ? "#FF8000"
            : "#70798F",
  });

  const navigate = useNavigate()


  const whereToNavigate = async (id, toQuery) => {
    if (toQuery) {
      navigate(`/progress-query`);
      return;
    }
    navigate(`/deposit-not-received-form/${encodeId(id)}`)
  }

  return (
    <section className="Withdrawal_card_holder">
      {diposit_history?.data?.map((card, index) => {
        const statusName = card?.RequestStatus?.name || "-";

        return (
          <div className="Withdrawal_card" key={card.id}>
            <div className="card-top">
              {/* Badge */}
              <span className="badge-withdraw" style={badgeStyle}>
                Recharge
              </span>

              {/* Status from RequestStatus.name */}
              <span
                className="status-completed"
                style={getStatusStyle(statusName)}
              >
                {statusName}
              </span>
            </div>

            <div className="card-body">
              <div className="row-item">
                <span className="label">Amount</span>
                <span className="value amount">
                  {formatAmount(card?.amount)}
                </span>
              </div>

              {/* <div className="row-item">
                <span className="label">Type</span>
                <span className="value">{card?.type}</span>
              </div> */}

              <div className="row-item">
                <span className="label">Time</span>
                <span className="value">
                  {formatNotifDate(card?.createdAt)}
                </span>
              </div>

              <div className="row-item">
                <span className="label">Order Number</span>
                <div className="value order-id">
                  <span className="order-text">{card?.order_no}</span>
                  <div
                    className="copy-wrapper"
                    onClick={() => handleCopy(card?.order_no, index)}
                  >
                    <FontAwesomeIcon icon={faCopy} className="copy-icon" />
                    {copiedIndex === index && (
                      <div className="copy-tooltip">Copied!</div>
                    )}
                  </div>
                </div>
              </div>

              {(statusName === "Failed" || statusName === "Rejected") && (
                <div className="btn_holder">
                  <button className="orange_btn" onClick={() => whereToNavigate(card?.id, card?.Deposit_Query)}>Submit Receipt</button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
}

export default Deposit_Not_Received_Card;
